import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutLocationCustomerXref extends Layout {
    buttonBillToExpand: Button;
    buttonLocationExpand: Button;
    horizontalspacerForEdiBilling: HorizontalSpacer;
    horizontalspacerForLocation: HorizontalSpacer;
    labelBillTo: Label;
    labelLocation: Label;
    panelBillTo: Panel;
    panelBillToButtons: Panel;
    panelBillToCollapsible: Panel;
    panelCustomerHeader: Panel;
    panelLocation: Panel;
    panelLocationButtons: Panel;
    panelLocationCollapsible: Panel;
    panelLocationHeader: Panel;
    sourceEdilocation: DataSource;
    tableBillTo: Table;
    tableLocation: Table;
}
